import { Box, Skeleton } from '@mui/material';
const SmartCardsLoading = ({ count = 3, variant = 'grid', hasQuickView = false }) => {
  const isStack = variant === 'stack';
  return (
    <Box
      sx={{
        display: isStack ? 'flex' : 'grid',
        flexDirection: isStack ? 'column' : undefined,
        width: '100%',
        gap: isStack ? '16px' : undefined,
        rowGap: isStack ? undefined : '24px',
        columnGap: isStack ? undefined : '24px',
        alignSelf: 'stretch',
        gridTemplateColumns: isStack ? undefined : {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          xl: 'repeat(4, minmax(0, 1fr))'
        },
        mt: isStack ? '16px' : '24px',
      }}
    >
      {Array.from({ length: count }).map((_, idx) => (
        <Box
          key={`smart-card-skeleton-${idx}`}
          sx={{
            border: '1px solid #E0E0E0',
            borderRadius: '24px',
            width: '100%',
            minHeight: '420px',
            p: '24px',
            boxSizing: 'border-box',
            background: '#FFF',
          }}
        >
          <Skeleton variant="text" width="70%" height={32} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: '12px', mb: 3 }} />
          <Skeleton variant="text" width="60%" height={28} />
          <Skeleton variant="text" width="80%" height={28} />
          <Skeleton variant="text" width="65%" height={28} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
            <Skeleton variant="rounded" width={40} height={32} sx={{ borderRadius: '16px' }} />
            <Box sx={{ display: 'flex', gap: 1 }}>
              {hasQuickView && (
                <Skeleton variant="rounded" width={70} height={32} sx={{ borderRadius: '16px' }} />
              )}
              <Skeleton variant="rounded" width={70} height={32} sx={{ borderRadius: '16px' }} />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SmartCardsLoading;
